import type { DecodeCmsContent, DecodeCmsContentResponse, DecodeHormoneReference } from "../types/decode";
import { apiFetch } from "./client";

export async function getDecodeContent(): Promise<DecodeCmsContentResponse> {
  return apiFetch<DecodeCmsContentResponse>("/api/v1/admin/decode/content");
}

export async function publishDecodeContent(
  content: DecodeCmsContent,
): Promise<DecodeCmsContentResponse> {
  return apiFetch<DecodeCmsContentResponse>("/api/v1/admin/decode/content/publish", {
    method: "PUT",
    body: JSON.stringify({ content }),
  });
}

export async function getDecodeHormones(): Promise<DecodeHormoneReference[]> {
  return apiFetch<DecodeHormoneReference[]>("/api/v1/admin/decode/hormones");
}
